module.exports = __webpack_public_path__ + "img/4-6-tour-1.5897f489.jpg";